export enum Signals {
  MessageReceived = 'MessageReceived',
  ChangeChatStatus = 'ChangeChatStatus',
  MessageSeen = 'MessageSeen',
  NewChatArrived = 'NewChatArrived'
}
